<template>
  <div class="cp-files">
    <div class="cp-files-header">
      <r-title type="subtitle-2">Файлы и ссылки</r-title>
    </div>
    <files :id="id" :source_id="sourceId" />
  </div>
</template>

<script>
import Files from "@/components/files/files";

export default {
  props: ["id", "source-id"],
  components: {
    Files
  }
};
</script>

<style lang="scss">
.cp-files {
  padding: 16px;
  border-right: 1px solid transparent;
  border-color: var(--dividers_low_contrast) !important;
  flex: 1;

  &-header {
    margin-bottom: 8px;
  }
}
</style>
